import React from "react"
import {
  useCurrentPlanRefScope,
  useMachineSnackbar,
  useRedirectUrl,
  useStateSetup,
  useProgramSync,
  useUserInitialSetup
} from "./hooks"

const StudyPlanMachineListeners: React.FC<React.PropsWithChildren<unknown>> = ({
  children
}) => {
  // Initialize user context
  useUserInitialSetup()

  // Handle URL → State synchronization
  useStateSetup()

  // Handle program changes from filters/context
  useProgramSync()

  // Handle State → URL navigation
  useRedirectUrl()

  // Handle other side effects
  useCurrentPlanRefScope()
  useMachineSnackbar()

  return children as React.ReactElement
}

export default StudyPlanMachineListeners
